import React from 'react'
import ProductLinesContainer from './product-lines/ProductLinesContainer'
import PropTypes from 'prop-types'

const MockupGeneratorTabContent = (props) => {
    const {products, singleBoard} = props
    return (
        <div className={`ContentListProductMockup${singleBoard ? ' BoardContainer' : ''}`}>
            {Array.isArray(products) &&
                products.map((product, index) => {
                    return (
                        <ProductLinesContainer {...props} key={`MockupGeneratorProduct_${index}`} product={product} />
                    )
                })}
        </div>
    )
}

MockupGeneratorTabContent.propTypes = {
    products: PropTypes.array.isRequired,
}

export default MockupGeneratorTabContent

